import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {FooterModuleState} from "./models/footer-module.state";
import {FooterModuleConfig} from "./footer-module.config";

export class FooterModuleStore extends BaseMobxStore {
  static injectables = [FooterModuleConfig, FooterModuleState];
}
